import React from 'react';
import { Modal } from 'react-bootstrap';

const VideoModal = ({ toggleModal, show, videoData }) => {
  return (
    <Modal
      show={show}
      backdrop="static"
      size="lg"
      centered
      className="animated slideInUp faster video-popup VideoPopup"
    >
      <Modal.Header>
        <button type="button" class="btn-close" onClick={(e) => toggleModal(e)}>
          X
        </button>
      </Modal.Header>
      <Modal.Body className="text-center">
        <iframe
          src={videoData?.redirecturl}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Modal.Body>
    </Modal>
  );
};
export default VideoModal;
